import { PublicSiteState, emptyAppState } from '../components/public_site.main.mod'
import { stateful, none, Widget, any } from 'widgets-for-react'
import { AppState } from '../components/cms/state/types.gen'
import { PublicSiteCustomRoutes } from '../components/public_site/custom_pages/types.mod'
import { application } from '../components/public_site/application.mod'
import { navigation } from '../components/public_site/templates/navigation.mod'
import { footer } from '../components/public_site/templates/footer.mod'
import { notfound_page } from '../components/public_site/templates/error_page.mod'
import { loader } from '../components/public_site/templates/loader.mod'
import { page } from '../components/public_site/templates/page.mod'
import ReactDOM from 'react-dom'
// import { myCustomPage } from '../components/public_site/custom_pages/my-custom-page'
import React from 'react';
import { I18nextProvider } from 'react-i18next'
import i18next, { i18n } from 'i18next'
import nl from '../locales/nl'
import en from '../locales/en'
import de from '../locales/de'
import { jsxToWidget } from '../components/cms/blocks/utils.gen'
import moment from 'moment'
import { fromJSX } from '../utils'

const i18n = function <I>(options: i18next.InitOptions) {
  i18next.init(options)
  return function (children: JSX.Element): Widget<I> {
    return jsxToWidget<I>(
      <I18nextProvider i18n={i18next}>
        {children}
      </I18nextProvider>
    )
  }
}

function getScrollPercent() {
  var documentElement = document.documentElement,
    body = document.body,
    scrollTop = Math.max(documentElement.scrollTop, body.scrollTop),
    scrollHeight = Math.max(documentElement.scrollHeight, body.scrollHeight) - documentElement.clientHeight;
  return Math.min(Math.max(Math.round(scrollTop / scrollHeight * 100), 0));
}

function ShouldUpdateScroll() {
  let now = moment()
  let diff = moment(now.diff(prev_time))
  if (diff.milliseconds() > 200) {
    prev_time = now
    let current_scroll = getScrollPercent()
    if (current_scroll > last_scroll) {
      last_scroll = current_scroll
    } else {
      return false
    }
    return true
  }
  return false
}

function UpdateScrollDataLayer() {
  if (ShouldUpdateScroll()) {
    if (last_scroll < 0) return
    window.dataLayer.push({
      event: "event.fccorporate", category: "Scroll", action: window.location.pathname, label: last_scroll
    });
  }
}

let state: PublicSiteState | "none" = "none"
let prev_time = moment()
let last_scroll = -1



const bootstrap = () =>
  ReactDOM.render(
    i18n<AppState<PublicSiteState, PublicSiteCustomRoutes>>({
      lng: window.wp.language,
      debug: false,
      initImmediate: true,
      resources: { nl, en, de }
    })(
      stateful<AppState<PublicSiteState, PublicSiteCustomRoutes>>()(
        s =>
          any<AppState<PublicSiteState, PublicSiteCustomRoutes>>({})([
            fromJSX(set_state => {
              if (s.state.page.page.kind == 'loaded') {
                state = s.state
              }
              return <div className='wrap'>
                {application(
                  { rootpath: '', rootpath_to_ignore: '/portal', login_address: '/portal' },
                  navigation,
                  footer,
                  notfound_page,
                  loader,
                  page,
                  {
                    // myCustomPage: myCustomPage,
                  } // Add custom pages here
                )(s).run(set_state)}
              </div>
            })
          ])
      )({
        current_widget: none(),
        route: {
          kind: '404'
        },
        state: emptyAppState(page)
      }).run(_ => null)
    ).run(_ => null),
    document.getElementById('react-content'),
    () => {
      document.getElementById('react-content').classList.add('init')
      
      removeLoader()

      document.addEventListener("wheel", function (event) {

        UpdateScrollDataLayer()
      })
      document.addEventListener("scroll", function (event) {

        UpdateScrollDataLayer()
      })
    }
  )

document.addEventListener('DOMContentLoaded', () => bootstrap())

const removeLoader = () => {
  const loader = document.getElementById('js--loader');
  if(loader == null) { return; }
  loader.remove();
}
